export const SocketChannelNamespaceType = {
    CORE: "CORE",
    SYNC: "SYNC",
    PRIVATE: "PRIVATE",
};
